import styled from "styled-components";
import { palette, size } from "styled-theme";
import { DEFAULT_PAPER_PADDING } from "../../constants/commonConstants";

const Wrapper = styled.div`
  background-color: ${palette("fieldWell", 0)};
  padding-top: 8px;
  
  @media only screen and (min-width: ${size("S")}) {
    margin: 0 ${DEFAULT_PAPER_PADDING}px;
    border-radius: 20px;
    margin-bottom: 20px;
  }
`;

export default Wrapper;